import { render, staticRenderFns } from "./pwa-snackbar.vue?vue&type=template&id=42c539b8"
import script from "./pwa-snackbar.vue?vue&type=script&lang=js"
export * from "./pwa-snackbar.vue?vue&type=script&lang=js"
import style0 from "./pwa-snackbar.vue?vue&type=style&index=0&id=42c539b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports